import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ThemeState {
  darkMode: boolean;
}

// Load theme from localStorage
const loadThemeFromStorage = (): boolean => {
  try {
    const savedTheme = localStorage.getItem('darkMode');
    return savedTheme ? JSON.parse(savedTheme) : false;
  } catch {
    return false;
  }
};

// Save theme to localStorage
const saveThemeToStorage = (darkMode: boolean) => {
  try {
    localStorage.setItem('darkMode', JSON.stringify(darkMode));
  } catch {
    // Ignore localStorage errors
  }
};

const initialState: ThemeState = {
  darkMode: loadThemeFromStorage(),
};

export const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    toggleTheme: (state) => {
      state.darkMode = !state.darkMode;
      saveThemeToStorage(state.darkMode);
    },
    setTheme: (state, action: PayloadAction<boolean>) => {
      state.darkMode = action.payload;
      saveThemeToStorage(state.darkMode);
    },
  },
});

export const { toggleTheme, setTheme } = themeSlice.actions;
export default themeSlice.reducer;
